import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import BaseCheckOutModal, {BaseCheckoutModalProps} from 'inventory/check-in-check-out/BaseCheckOutModal';

export default function CheckOutModal(
  props: Omit<BaseCheckoutModalProps, 'statusWarningTrackingParams' | 'title' | 'alternateAssigneeConfig'>
): JSX.Element {
  return (
    <BaseCheckOutModal
      items={props.items}
      onCheckOut={props.onCheckOut}
      onRequestClose={props.onRequestClose}
      title="Check out"
      statusWarningTrackingParams={{
        actionOrigin: props.analyticsMetadata?.actionOrigin ?? ActionOrigin.UI_UNDETERMINED,
        actionAttempted: 'check_out',
        eventGroupId: props.analyticsMetadata?.eventGroupId ?? Analytics.makeAnalyticsEventId(),
      }}
      analyticsMetadata={{...props.analyticsMetadata, modalType: 'check_out'}}
      shouldAlwaysShowSampleStatusTable={props.shouldAlwaysShowSampleStatusTable}
    />
  );
}
